// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2B5TC","header":"PatientBlock_header__1w4-k","label":"PatientBlock_label__1cMQa","option":"PatientBlock_option__saBLb"};